import * as React from 'react';
import {
	BooleanField,
	Datagrid,
	DateField,
	EmailField,
	ImageField,
	ListProps,
	NumberField,
	ReferenceField,
	TextField,
	UrlField
} from 'react-admin';
import { PhoneField } from '../components/PhoneField';
import './CoachDatagrid.scss';

export const CoachDatagrid = (props: ListProps): React.ReactElement => {
	return (
		<Datagrid rowClick="edit" className="coaches-table" optimized
		          hasBulkActions={true}
		          rowStyle={(row: any) => ({ borderRightColor: row._readAt ? '#49d18c' : '#bbbbbb' })}>
			<TextField source="id" label="#"/>
			<TextField source="fullName" label="FULL_NAME"/>
			<PhoneField source="user.phone" label="PHONE"/>
			<EmailField source="user.email" label="EMAIL"/>
			<ImageField source="profileImageUrl" label="PROFILE_IMAGE"/>
			<DateField source="birthDate" label="BIRTH_DATE"/>
			<NumberField source="height" label="HEIGHT"/>
			<NumberField source="weight" label="WEIGHT"/>
			<ReferenceField source="coachId" reference="clients" label="COACH">
				<TextField source="fullName"/>
			</ReferenceField>
			<ReferenceField source="tagId" reference="tags" label="TAG">
				<TextField source="title"/>
			</ReferenceField>

			<BooleanField source="approvedByCoach" label="APPROVED_BY_COACH"/>
			<TextField source="address.addressStr" label="ADDRESS"/>
			<UrlField source="menuPdfUrl" label="MENU_PDF_URL"/>
			{/*<TextField source="note" label="NOTE"/>*/}
		</Datagrid>
	);
};
